import React from 'react';
import { Row, Col, Card, Typography, List, Button } from 'antd';
import {
  ToolOutlined,
  ThunderboltOutlined,
  SettingOutlined,
  CheckCircleOutlined,
  AppstoreOutlined,
  ArrowRightOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { shopConfig, getThemeColors } from '../../config/shop.config';

const { Title, Text, Paragraph } = Typography;

const ServicesSection: React.FC = () => {
  const themeColors = getThemeColors();
  const navigate = useNavigate();

  return (
    <div id="services" style={{ padding: '80px 20px', backgroundColor: '#f9fafb' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Section Header */}
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <Title level={2} style={{ color: themeColors.primary }}>Our Services</Title>
          <Paragraph style={{ fontSize: '18px', color: '#6b7280', maxWidth: '700px', margin: '0 auto' }}>
            One-stop shop for all your automotive needs - from complex repairs to routine maintenance
          </Paragraph>
        </div>

        {/* Services Grid */}
        <Row gutter={[32, 32]}>
          {/* Heavy Line Services */}
          <Col xs={24} md={12}>
            <Card
              style={{
                height: '100%',
                borderRadius: '16px',
                border: '2px solid #e5e7eb',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.07)',
              }}
            >
              <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                <div
                  style={{
                    width: '70px',
                    height: '70px',
                    backgroundColor: `${themeColors.primary}15`,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 16px',
                  }}
                >
                  <ThunderboltOutlined style={{ fontSize: '32px', color: themeColors.primary }} />
                </div>
                <Title level={3} style={{ marginBottom: '8px' }}>
                  {shopConfig.services.heavyLine.title}
                </Title>
                <Text type="secondary">{shopConfig.services.heavyLine.description}</Text>
              </div>

              <List
                dataSource={shopConfig.services.heavyLine.items}
                renderItem={(item) => (
                  <List.Item style={{ border: 'none', padding: '8px 0' }}>
                    <CheckCircleOutlined style={{ color: '#10b981', marginRight: '12px' }} />
                    <Text>{item}</Text>
                  </List.Item>
                )}
              />
            </Card>
          </Col>

          {/* Maintenance Services */}
          <Col xs={24} md={12}>
            <Card
              style={{
                height: '100%',
                borderRadius: '16px',
                border: '2px solid #e5e7eb',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.07)',
              }}
            >
              <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                <div
                  style={{
                    width: '70px',
                    height: '70px',
                    backgroundColor: `${themeColors.accent}15`,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 16px',
                  }}
                >
                  <SettingOutlined style={{ fontSize: '32px', color: themeColors.accent }} />
                </div>
                <Title level={3} style={{ marginBottom: '8px' }}>
                  {shopConfig.services.maintenance.title}
                </Title>
                <Text type="secondary">{shopConfig.services.maintenance.description}</Text>
              </div>

              <List
                dataSource={shopConfig.services.maintenance.items}
                renderItem={(item) => (
                  <List.Item style={{ border: 'none', padding: '8px 0' }}>
                    <CheckCircleOutlined style={{ color: '#10b981', marginRight: '12px' }} />
                    <Text>{item}</Text>
                  </List.Item>
                )}
              />
            </Card>
          </Col>
        </Row>

        {/* One-Stop Shop Message */}
        <div
          style={{
            marginTop: '48px',
            textAlign: 'center',
            padding: '32px',
            backgroundColor: themeColors.primary,
            borderRadius: '16px',
            color: 'white',
          }}
        >
          <ToolOutlined style={{ fontSize: '40px', marginBottom: '16px' }} />
          <Title level={3} style={{ color: 'white', marginBottom: '8px' }}>
            {shopConfig.guarantees.oneStopShop.title}
          </Title>
          <Text style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.9)', display: 'block', marginBottom: '24px' }}>
            {shopConfig.guarantees.oneStopShop.description}
          </Text>
          <Button
            type="default"
            size="large"
            icon={<AppstoreOutlined />}
            onClick={() => navigate('/services')}
            style={{
              backgroundColor: 'white',
              color: themeColors.primary,
              borderColor: 'white',
              fontWeight: 600,
              height: '50px',
              padding: '0 32px',
              fontSize: '16px',
              borderRadius: '8px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            }}
          >
            View All Services <ArrowRightOutlined />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ServicesSection;
